import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class CreateOtherDocument {

    public file: FileMetaDTO | null = null;
    public comment: string | null = null;

}
